import store from '../store';
import Vue from 'vue';

const mapRolesConfigToAuthorization = config => {
    const authorization = {
        admin: false,
        services: [],
        subpages: [],
        components: []
    };

    //managing Iframe services
    const result = Object.keys(config).filter(
        element => element.toUpperCase().includes('IFRAME') && !element.toUpperCase().includes('INSTANCE')
    );
    result.forEach(iframeService => {
        store.state.groups.configGroups.push({
            role: ['admin', `${iframeService}.user`],
            authorizeServices: [iframeService]
        });
    });
    if (config === 'developmentMode') {
        authorization.admin = true;
        store.state.groups.configGroups.forEach(group => {
            if (group.authorizeServices) {
                authorization.services = authorization.services.concat(group.authorizeServices);
            }
            if (group.authorizeSubpages) {
                authorization.subpages = authorization.subpages.concat(group.authorizeSubpages);
            }
            if (group.authorizeComponents) {
                authorization.components = authorization.components.concat(group.authorizeComponents);
            }
        });
        return authorization;
    }

    for (const [roleType, roleTypeValue] of Object.entries(config.roles)) {
        if (roleType === 'admin' && roleTypeValue === true) authorization.admin = true;

        if (typeof roleTypeValue === 'object') {
            for (const [permission, permissionValue] of Object.entries(roleTypeValue)) {
                if (permissionValue || authorization.admin) {
                    store.state.groups.configGroups.forEach(group => {
                        if (authorization.admin || group.role.includes(`${roleType}.${permission}`)) {
                            if (group.authorizeServices) {
                                authorization.services = authorization.services.concat(group.authorizeServices);
                            }
                            if (group.authorizeSubpages) {
                                authorization.subpages = authorization.subpages.concat(group.authorizeSubpages);
                            }
                            if (group.authorizeComponents) {
                                authorization.components = authorization.components.concat(group.authorizeComponents);
                            }
                        }
                    });
                }
            }
        }
        if (
            roleType !== 'admin' &&
            ((!authorization.services.includes(roleType) && roleTypeValue?.user) || authorization.admin === true)
        ) {
            authorization.services = authorization.services.concat(roleType);
        }
    }

    if (config?.docsPortlets) {
        for (let i = 0; i < config.docsPortlets.length; i++) {
            authorization.services = [...authorization.services, config.docsPortlets[i]];
        }
    }
    return authorization;
};

const state = () => ({
    authorization: null,
    configGroups: [
        {
            role: ['admin', 'deliveries.NIN_user'],
            authorizeServices: ['deliveries'],
            authorizeSubpages: ['NIN']
        },
        {
            role: ['admin', 'deliveries.NCN_user'],
            authorizeServices: ['deliveries'],
            authorizeSubpages: ['NCN']
        },
        {
            role: ['admin', 'deliveries.read_user'],
            authorizeComponents: ['Read']
        },
        {
            role: ['admin', 'deliveries.open_user'],
            authorizeComponents: ['Create']
        },
        {
            role: ['admin', 'deliveries.close_user'],
            authorizeComponents: ['Close']
        },
        {
            role: ['admin', 'deliveries.delete_user'],
            authorizeComponents: ['Delete']
        },
        {
            role: ['admin', 'trackandtrace.user', 'trackandtrace.anon'],
            authorizeServices: ['trackandtrace'],
            authorizeSubpages: [
                'trackandtrace.details.details',
                'trackandtrace.events.events',
                'trackandtrace.content.content',
                'trackandtrace.documents.documents'
            ]
        },
        {
            role: ['admin', 'genericsearch.user'],
            authorizeServices: ['genericsearch']
        },
        {
            role: ['admin', 'docs.user'],
            authorizeServices: ['docs']
        },
        {
            role: ['admin', 'BI.user'],
            authorizeServices: ['BI']
        },
        {
            role: ['admin', 'BPM.user'],
            authorizeServices: ['BPM']
        },
        {
            role: ['admin', 'Statistic.user'],
            authorizeServices: ['Statistic']
        }
    ],
    userRoles: null,
    connected: false
});

const mutations = {
    setUserRolesAndAuthorization(state, config) {
        if (config === 'developmentMode') {
            state.authorization = mapRolesConfigToAuthorization(config);
        } else {
            state.userRoles = config.roles;
            state.authorization = mapRolesConfigToAuthorization(config);
        }
        Vue.set(state, 'connected', true);
    }
};

export default {
    state,
    mutations
};
